<form class="fix-editor">
  <mat-form-field class="ag-row fix-mat-form">
    <input #dateInput matInput tabindex="0" [type]="_inputType"
           [formControl]="formControl"
           [errorStateMatcher]="matcher"
           dateMask
           [maskOptions]="maskConfigOptions"
           autofocus>
  </mat-form-field>
</form>
